import { render, staticRenderFns } from "./ProcesosInternoApostar.vue?vue&type=template&id=fb260f30&scoped=true"
import script from "./ProcesosInternoApostar.vue?vue&type=script&lang=js"
export * from "./ProcesosInternoApostar.vue?vue&type=script&lang=js"
import style0 from "./ProcesosInternoApostar.vue?vue&type=style&index=0&id=fb260f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb260f30",
  null
  
)

export default component.exports